var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCurrencyEuro = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.086 13.914A2.95 2.95 0 0 0 13.225 15H16v2h-2.775a2.952 2.952 0 0 0 3.35 1.893 2.95 2.95 0 0 0 1.51-.807L19.5 19.5a4.95 4.95 0 0 1-8.348-2.5H10v-2h1.152a4.95 4.95 0 0 1 8.348-2.5l-1.414 1.414Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 16c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10S6 21.523 6 16Zm10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
})));
export default SvgCurrencyEuro;